var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "13px",
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 33") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sprint-1-/-Abgabe",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XLg_Nav-Level1_tooltip",
    transform: "translate(-1352.000000, -63.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1243.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "overlay",
    transform: "translate(0.000000, 4.555556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.852941, 5.857143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.129257,9.86466165 L108.400172,9.86466165 L108.400172,7.23169521 C108.400172,6.60376853 108.389242,5.79607966 107.501747,5.79607966 C106.60223,5.79607966 106.464879,6.48038147 106.464879,7.18666603 L106.464879,9.86466165 L104.737616,9.86466165 L104.737616,4.45016791 L106.395293,4.45016791 L106.395293,5.19049028 L106.418974,5.19049028 C106.649592,4.7646631 107.213567,4.31578947 108.054792,4.31578947 C109.805737,4.31578947 110.129257,5.43690985 110.129257,6.89521728 L110.129257,9.86466165 Z M103.240428,3.69924812 C102.742562,3.69924812 102.341331,3.28497265 102.341331,2.7742681 C102.341331,2.26389953 102.742562,1.84962406 103.240428,1.84962406 C103.736008,1.84962406 104.138545,2.26389953 104.138545,2.7742681 C104.138545,3.28497265 103.736008,3.69924812 103.240428,3.69924812 L103.240428,3.69924812 Z M104.138545,9.86466165 L102.341331,9.86466165 L102.341331,4.31578947 L104.138545,4.31578947 L104.138545,9.86466165 Z M111.452324,0 L101.018619,0 C100.75647,0 100.544118,0.218544643 100.544118,0.487973214 L100.544118,11.2259464 C100.544118,11.4957411 100.75647,11.7142857 101.018619,11.7142857 L111.452324,11.7142857 C111.714119,11.7142857 111.926471,11.4957411 111.926471,11.2259464 L111.926471,0.487973214 C111.926471,0.218544643 111.714119,0 111.452324,0 L111.452324,0 Z",
    id: "Fill-33"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.0c9f9a3f.svg";
export { ForwardRef as ReactComponent };